// Small hook: persist last 5 searches per module in localStorage.
import { useCallback, useEffect, useState } from 'react';

const KEY = 'elite_recent_searches';
const MAX = 5;

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { return {}; }
};

const write = (val) => {
  try { localStorage.setItem(KEY, JSON.stringify(val)); } catch {}
};

export const useRecentSearches = (moduleKey) => {
  const [items, setItems] = useState(() => read()[moduleKey] || []);

  useEffect(() => {
    setItems(read()[moduleKey] || []);
  }, [moduleKey]);

  const add = useCallback((entry) => {
    const all = read();
    const list = all[moduleKey] || [];
    const dedup = [entry, ...list.filter((it) => JSON.stringify(it) !== JSON.stringify(entry))].slice(0, MAX);
    all[moduleKey] = dedup;
    write(all);
    setItems(dedup);
  }, [moduleKey]);

  const clear = useCallback(() => {
    const all = read();
    delete all[moduleKey];
    write(all);
    setItems([]);
  }, [moduleKey]);

  return { items, add, clear };
};
